module.exports = __webpack_public_path__ + "static/img/Felise-Kaufusi.e8020f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Felise-Kaufusi.jpg
// module id = n3Zu
// module chunks = 0